module.exports = __webpack_public_path__ + "static/media/iconTwo.58b55128.svg";